/**
 * Timezone options for the TelegramUserSettings component.
 * Currently only used when `show-timezone` is true.
 * Backend stores the raw IANA name and only accepts values returned by
 * timezone_identifiers_list() — keep entries in sync.
 */
export const timezoneOptions = [
  { label: '(UTC) Coordinated Universal Time', value: 'UTC' },
  { label: '(UTC-08:00) Pacific Time — Los Angeles', value: 'America/Los_Angeles' },
  { label: '(UTC-07:00) Mountain Time — Denver', value: 'America/Denver' },
  { label: '(UTC-06:00) Central Time — Chicago', value: 'America/Chicago' },
  { label: '(UTC-05:00) Eastern Time — New York', value: 'America/New_York' },
  { label: '(UTC-03:00) Sao Paulo', value: 'America/Sao_Paulo' },
  { label: '(UTC+00:00) London', value: 'Europe/London' },
  { label: '(UTC+01:00) Berlin', value: 'Europe/Berlin' },
  { label: '(UTC+01:00) Paris', value: 'Europe/Paris' },
  { label: '(UTC+02:00) Chisinau', value: 'Europe/Chisinau' },
  { label: '(UTC+02:00) Kyiv', value: 'Europe/Kyiv' },
  { label: '(UTC+02:00) Cairo', value: 'Africa/Cairo' },
  { label: '(UTC+03:00) Istanbul', value: 'Europe/Istanbul' },
  { label: '(UTC+03:00) Moscow', value: 'Europe/Moscow' },
  { label: '(UTC+04:00) Dubai', value: 'Asia/Dubai' },
  { label: '(UTC+05:00) Karachi', value: 'Asia/Karachi' },
  { label: '(UTC+05:30) New Delhi', value: 'Asia/Kolkata' },
  { label: '(UTC+07:00) Bangkok', value: 'Asia/Bangkok' },
  { label: '(UTC+08:00) Singapore', value: 'Asia/Singapore' },
  { label: '(UTC+08:00) Shanghai', value: 'Asia/Shanghai' },
  { label: '(UTC+09:00) Tokyo', value: 'Asia/Tokyo' },
  { label: '(UTC+10:00) Sydney', value: 'Australia/Sydney' },
  { label: '(UTC+12:00) Auckland', value: 'Pacific/Auckland' },
];

export default timezoneOptions;
